module.exports = __webpack_public_path__ + "img/downloadbg1.04eca0b1.png";